export default __webpack_public_path__ + "static/media/img6.79cd72ce.svg";